/*==========================================================
HOMEPAGE RESPONSIVE SCRIPTS
==========================================================*/

$(function() {
    if ($('#uber').hasClass('homepage')) {
        //News and Events Feed
        if ($().matchHeight) {
            $('.matchHeight').matchHeight();
        }
    }
});


//events carouse
$(window).on('load', function () {
    if ($('.newsFeed .dateList-events').length) {
        

        var optionsGroup = {
            cellAlign: 'left',
            cellSelector: '.dateList_item',
            groupCells: true,
            contain: true,
            imagesLoaded: true,
            pageDots: false
        };

        var $news = $('.newsFeed.news .dateList-events');
            

        $news.flickity(optionsGroup);
        

        var newsData = $news.data('flickity');
        
        if ($news.length && newsData.cells.length <= 1) {
            $('.flickity-button').hide();
        }

    }
})



//idliketo
